<mat-form-field [floatLabel]="floatLabel"
                [appearance]="appearance"
                [formGroup]="formGroup">
  <mat-label>{{label | translate}}</mat-label>
  <textarea matInput
            [readonly]="isReadonly"
            [formControl]="control"
            [id]="'nc-textarea-' + id"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="10"
            autocomplete="off"
            [attr.maxLength]="maxLength > 0 ? maxLength : null"
  >
  </textarea>
  <mat-hint *ngIf="maxLength" align="end">{{control.value ? control.value.length : 0}} / {{maxLength}}</mat-hint>
  <mat-error *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</mat-form-field>
